
import skills_logo from '../assets/skills_logo.png'


export default function Navbar() {
  return (
    <div className="relative bg-skills_blue-700 z-50">
      <div className="flex items-center justify-between p-6 md:justify-start md:space-x-10">
        <div className='flex'>
          <a href="https://skillsengine.com" target={"1"} className="flex">
            <span className="sr-only">Skills Engine</span>
            <img
              className="h-8 w-auto sm:h-10"
              src={skills_logo}
              alt=""
            />
          </a>
          <p className={"mx-3 pt-2 font-extrabold"} >Job Post Generator</p>
        </div>
        <div className=" md:flex md:flex-1 md:items-center md:justify-end">
          <div className="flex items-center md:ml-12">
            <a href="https://skillsengine.com" target={"2"} className="text-base font-medium text-white hover:text-gray-400">
              About
            </a>
            <a
              href="https://skillsengine.com" target={"3"}
              className="ml-8 inline-flex items-center justify-center rounded-md border border-transparent bg-amber-400 px-4 py-2 text-base font-medium text-skills_blue-700 shadow-sm hover:text-gray-400 hover:bg-amber-300 "
            >
              Sign up CTA
            </a>
          </div>
        </div>
      </div>

    </div>
  )
}
